import { enhancedApi } from '../api';

export const { useGetApiV1UnderwritingModelsQuery } = enhancedApi;
